import { useState } from 'react';
import Button from '@/atoms/buttons/Button';
import Select from '@/atoms/inputs/Select/Select';
import Paragraph from '@/atoms/typography/Paragraph';
import OutlineCard from '@/organisms/cards/OutlineCard/OutlineCard';
import TagListOverview from '@/organisms/tags/TagListOverview/TagListOverview';
import Size from '@enums/Size';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Stack from '@mui/material/Stack';
import { EntityMetric } from '@/lib/enums';

const TagListHeader = ({
  showMetricSelection,
  selectedTag,
  initialMetric,
  isCondensedView,
  onSelectMetricType,
  onSelectTag,
}) => {
  const options = [
    {
      id: EntityMetric.PERCENTAGE,
      label: 'Percentage',
    },
    {
      id: EntityMetric.HOURS,
      label: 'Hours',
    },
  ];

  const [selected, setSelected] = useState(options[0]);

  const handleClose = () => {
    onSelectTag?.();
  };
  const handleSelectMetricType = (option) => {
    setSelected(option);
    onSelectMetricType(option.id);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {showMetricSelection && (
        <>
          <Paragraph size={Size.X_SMALL} overrideStyles={{ mb: 0 }}>
            Show metric
          </Paragraph>
          <Select
            initialValue={selected}
            onChange={handleSelectMetricType}
            options={options}
            optionLabel="label"
          />
        </>
      )}
      {selectedTag && !isCondensedView && (
        <Button
          onClick={handleClose}
          label="Close tag summary"
          startIcon={<ArrowBackIcon />}
          color="primary"
          variant="text"
        />
      )}
    </Stack>
  );
};

const TagListCard = ({
  title,
  isCondensedView = false,
  comparisonMetrics,
  combineTagCategories,
  showMetricSelection,
  showCustomTags,
  showComparisonDifferences,
  visibleTagSet,
  useComparison = false,
}) => {
  const [selectedTag, setSelectedTag] = useState(null);
  const [metricType, setMetricType] = useState(EntityMetric.PERCENTAGE);

  const handleSelectTag = (tag) => {
    setSelectedTag(tag);
  };

  const handleSelectMetricType = (option) => {
    setMetricType(option);
  };

  return (
    <OutlineCard
      title={title}
      headerAction={
        <TagListHeader
          selectedTag={selectedTag}
          showMetricSelection={showMetricSelection}
          selectedTag={selectedTag}
          isCondensedView={isCondensedView}
          onSelectMetricType={handleSelectMetricType}
          onSelectTag={handleSelectTag}
        />
      }
      margin={0}
      padding={0}
    >
      <TagListOverview
        isCondensedView={isCondensedView}
        combineTagCategories={combineTagCategories}
        initialSelectedTag={selectedTag}
        metricType={metricType}
        showCustomTags={showCustomTags}
        onSelectTag={handleSelectTag}
        visibleTagSet={visibleTagSet}
        comparisonMetrics={comparisonMetrics}
        useComparison={useComparison}
        showComparisonDifferences={showComparisonDifferences}
      />
    </OutlineCard>
  );
};

export default TagListCard;
